
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cake-request-form",
      function () {
        return require("private-next-pages/cake-request-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cake-request-form"])
      });
    }
  